import script from "./whole-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./whole-content.vue?vue&type=script&setup=true&lang=ts"

import "./whole-content.vue?vue&type=style&index=0&id=5f1a4732&lang=scss"

const __exports__ = script;

export default __exports__